import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ActivateLoadingAction, DeactivateLoadingAction } from '../../redux/ui.actions';
import Swal from 'sweetalert2';
import {ActivatedRoute} from '@angular/router';

import pdfMake from 'pdfmake/build/pdfMake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss']
})
export class RecipeComponent implements OnInit {
  bookingsPast = [];
  /*recipes:any = [
    {id:1,name:'Omeprazol de 1000mg',quantity:'antes de cada alimento', doctor_id:{},patient_id:{}},
    {id:1,name:'Paracetamol de 950mg',quantity:'Uno al despertar y otro al dormir', doctor_id:{},patient_id:{}},
    {id:1,name:'Diazepan de 100mg',quantity:'Cada 24 Hrs', doctor_id:{},patient_id:{}}
  ];*/
  recipes=[];
  currentRec:number = 0;
  patients = [];
  patient_id = '';
  disabled = true;
  name = '';
  quantity = '';
  medications = [];
  isLoading = false;
  isView = false;
  title:string = "Nueva Receta";

  constructor(private service: AuthService, private route: ActivatedRoute) {
    this.isLoading = true;
    //this.getBookingsPast();
    this.getData();

   }

  ngOnInit() {
    let pat = this.route.snapshot.queryParamMap.get("patient_id");
    if(pat){
      this.patient_id = pat;
    }
  }

  addMedication(){
    this.medications.push({name:'',quantity:'',patient_id:this.patient_id,doctor_id:this.service.user.id});
  }

  changePatient(){
    this.medications = [];
    this.medications.push({name:'',quantity:'',patient_id:this.patient_id,doctor_id:this.service.user.id});
  }

  closeView(){
    this.patient_id = "";
    this.medications = [];
    this.isView = false;
    this.title = "Nueva Receta";
  }

  deleteMedication(index){
    //if(index > 0)
    this.medications.splice(index,1);
  }

  deleteRecipe(folio){
    if(folio){
      Swal.fire({
        title:'Esta seguro de borrar esta receta?'
      }).then((result) => {
        console.log(result);
        if(result){//isConfirmed
          this.service.deleteRecipe({folio:folio}).subscribe (d =>{
            console.log(d)
            Swal.fire({
              icon: 'success',
              title: 'Exitoso',
              text: "Receta eliminada",
            });
            this.medications = [];
            this.patient_id = "";
            this.getData();
          },  (res)=>{
            res = this.service.decrypt(res.error.message,'private')
          });
        }
      });
    }
  }

  generatePDF(data){
    var meds = [[{text:'Medicamento', style:'header'}, {text:'Dosis', style:'header'}]];
    data.medications.forEach(m => {
      meds.push([{text:m.name, bold:true}, m.quantity]);
    });
    const documentDefinition = {
      content: [
        {
          columns:[
            [{text:'RECETA MÉDICA', bold:true, fontSize:20, alignment:'center', margin:[0,0,0,20]}],
            [{image:'logo', width:50, alignment:'right'}]
          ]
        },
        {
          columns:[
            [
              {text:'PACIENTE', bold:true},
              {text:data.patient_id.first_name + " " + data.patient_id.last_name, style:'name'},
              {text:data.patient_id.email},
              {text:data.patient_id.country_code + " " + data.patient_id.phone,margin:[0,0,0,20],},
            ],
            [
              {text:'DOCTOR', bold:true},
              {text:data.doctor_id.first_name + " " + data.doctor_id.last_name, style:'name'},
              {text:data.doctor_id.email},
              {text:data.doctor_id.country_code + " " + data.doctor_id.phone, margin:[0,0,0,20],},
            ]
          ]
        },
        {
          text:'Medicamentos:',
          style:'subtitle'
        },
        {
          table:{
            headerRows:1,
            widths:['*','*'],
            body:meds
          }
        }
      ],
      styles:{
        name:{
          fontSize:16,
          bold:true
        },
        header:{
          decoration:'underline',
          bold:true,
          fontSize:18,
          alignment:'center'
        },
        subtitle:{
          bold:true,
          fontSize:16,
          italics:true,
          margin:[0,10,0,10]
        }
      },
      images:{
        logo: 'data:image/png;base64,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'
      }
    };
    pdfMake.createPdf(documentDefinition).open();
  }

  getBookingsPast() {
    this.disabled = true;
    this.service.endDatesFinish().subscribe((d: any) => {
      let decData = JSON.parse(this.service.decrypt(d.message, 'private'));
      this.isLoading = false;
      console.log(decData.data.items)
      this.bookingsPast = decData.data.items;
      let finded = false;
      decData.data.items.forEach(item => {
        finded = false;
        for (let p = 0; p < this.patients.length; p++) {
          if(this.patients[p].id == item.patient_user_id.id){
            finded = true; break;
          }
        }
        if(!finded)
          this.patients.push(item.patient_user_id);
      });
      this.disabled = false;
      //this.store.dispatch(new DeactivateLoadingAction());
    }, err => {
      //this.store.dispatch(new DeactivateLoadingAction());
      console.log(err)
    });

  }

  getData(){
    this.recipes = [];
    this.service.getRecipes().subscribe((d:any) => {
      let decData = JSON.parse(this.service.decrypt(d.message, 'private'));
      //this.recipes = decData.data.items;
      this.isLoading = false;
      if(decData.data.items.length > 0){
        decData.data.items.forEach(item => {
          let finded = false;
          for (let i = 0; i < this.recipes.length; i++) {
            if(this.recipes[i].folio == item.folio){
              this.recipes[i].medications.push({name:item.name, quantity:item.quantity, id:item.id});
              finded = true;
              break;
            }
          }
          if(!finded){
            this.recipes.push({created_at:item.created_at, doctor_id:item.doctor_id, patient_id:item.patient_id,folio:item.folio,
              medications:[{name:item.name, quantity:item.quantity, id:item.id}]});
          }
        });
      }
    }, err =>{
      console.log(err)
    });
  }

  saveRecipe(){
    if(this.medications.length){
      for (let m = 0; m < this.medications.length; m++) {
        if(this.medications[m].name == ""){
          this.medications.splice(m,1);m--;
        }
      }
      if(this.medications.length <= 0){
        Swal.fire({
          icon: 'warning',
          title: 'No se pudo guardar la receta',
          text: "Es necesario tener medicamentos",
        });
        return;
      }
      this.service.setRecipe({recipes:this.medications}).subscribe (d =>{
        console.log(d)
        Swal.fire({
          icon: 'success',
          title: 'Bien!',
          text: "Receta guardada",
        });
        this.medications = [];
        this.patient_id = "";
        this.getData();
      },(res)=>{
        res = this.service.decrypt(res.error.message,'private')
      });
    }
  }

  viewRecipe(data){
    if(data){
      this.title = "Detalle Receta";
      this.isView = true;
      this.medications = [];
      this.patient_id = data.patient_id.id;
      data.medications.forEach(m => {
        this.medications.push({name:m.name,quantity:m.quantity});
      });
    }
  }
}
